import { createTheme } from "@mui/material/styles";
import colors from "./colors";
import { MuiButton } from "./components/button";
import { MuiCheckbox } from "./components/checkbox";
import {
  MuiDialog,
  MuiDialogActions,
  MuiDialogTitle,
} from "./components/dialog";
import { MuiFormHelperText } from "./components/form";
import { MuiOutlinedInput } from "./components/input";
import { MuiList } from "./components/list";
import { MuiListItemButton } from "./components/list";
import { MuiSwitch } from "./components/switch";
import { MuiTableCell } from "./components/table";
import { MuiTab } from "./components/tabs";
import { MuiTabs } from "./components/tabs";
import { MuiTextField } from "./components/textfield";
import { MuiTooltip } from "./components/tooltip";
import typography from "./typography";

const theme = createTheme({
  typography,
  palette: {
    primary: {
      main: colors.blue[100],
    },
    background: {
      default: colors.background.light,
    },
    error: {
      main: colors.red[100],
    },
    success: {
      main: colors.green[100],
    },
    warning: {
      // Map brand gold into MUI's warning palette for idiomatic usage
      main: colors.gold[60],
      light: colors.gold[25],
      dark: colors.gold[100],
    },
  },
  components: {
    MuiButton,
    MuiCheckbox,
    MuiDialog,
    MuiDialogActions,
    // @ts-expect-error
    MuiDialogTitle,
    MuiFormHelperText,
    MuiList,
    MuiListItemButton,
    MuiOutlinedInput,
    MuiSwitch,
    MuiTableCell,
    MuiTab,
    MuiTabs,
    MuiTextField,
    MuiTooltip,
  },
});

export default theme;
